const PERSONAL = ["gmail.", "googlemail.", "hotmail.", "outlook.", "live.", "yahoo.", "icloud.", "me.com", "aol.", "msn.", "protonmail.", "proton.me", "btinternet.", "sky.com", "virginmedia.", "gmx.", "mail.com", "ymail."];

export const isPersonalEmail = (email) => {
  const domain = (email.split("@")[1] || "").toLowerCase();
  return !!domain && PERSONAL.some((p) => domain.startsWith(p) || domain === p);
};
